<template>
  <v-avatar
    :size="size"
    :class="{'p-social-media-channel-avatar--no-image': imageError }"
    class="p-social-media-channel-avatar"
  >
    <span
      v-if="imageError"
      v-text="char"
      class="white--text text-h4"
    ></span>
    <img
      v-else
      v-bind="$attrs"
      :src="imageSrc"
      @error="onImageError"
    />
  </v-avatar>
</template>


<script>
import axios from 'axios'

import { socialMedia } from '@/constants'


export default {
  props: {
    socialMediaChannel: {
      type: Object
    },
    size: {
      type: Number,
      default: 60
    }
  },


  data () {
    return {
      imageSrc: null,
      imageError: false
    }
  },


  computed: {
    char () {
      return this.socialMediaChannel.name[0]
    }
  },


  methods: {
    onImageError () {
      this.imageError = true
    },

    async initImage () {
      let src = null

      switch (this.socialMediaChannel.socialMediaId) {
        case socialMedia.wordPress: {
          src = await this.getWordPressFaviconUrl()
        }
      }

      this.imageSrc = src

      if (!src) {
        this.imageError = true
      }
    },

    async getWordPressFaviconUrl () {
      try {
        const url = new URL(process.env.VUE_APP_WORDPRESS_PLUGIN_RELATIVE_URL + '/icon', this.socialMediaChannel.externalId)
        const response = await axios.get(url.href)

        if (response.status === 200) {
          return response.data
        }
      } catch (error) {
        this.$log.error(error)
      }

      return null
    }
  },


  async created () {
    try {
      await this.initImage()
    } catch (error) {
      this.$log.error(error)
    }
  }
}
</script>
